import React from 'react'
import GroupedPlanCard from 'common/GroupedPlanCard'
import { Product } from 'common/Products/types'
import { orderByLength, orderByDataLimit } from 'common/Products'
import { groupBy } from 'common/Utils'

interface AllPlanlistProps {
  plans: Product[]
}

const AllPlanlist = ({ plans }: AllPlanlistProps) => {
  // A Flex plan's allowance is per year, not per month, so it never shares a card
  // with a monthly-data plan of the same size.
  const groupedPlans = groupBy(
    plans
      .sort(orderByDataLimit)
      .map((plan) => ({ ...plan, group: `${plan.data}-${plan.is_flex}` })),
    'group'
  )
  return (
    <div>
      {Object.keys(groupedPlans)
        .sort((a, b) => parseFloat(a) - parseFloat(b))
        .map((group) => {
          const sortedPlans = [...groupedPlans[group]].sort(orderByLength)

          return (
            <GroupedPlanCard
              key={group}
              plans={sortedPlans}
              color={sortedPlans[0].colour}
              groupTitle={sortedPlans[0].title}
              groupSize={Number(sortedPlans[0].data)}
            />
          )
        })}
    </div>
  )
}

export default AllPlanlist
